export default __webpack_public_path__ + "static/media/portfolio-sass.935e5e76.jpg";